import { Checkbox } from 'primereact/checkbox';
import { Dropdown } from 'primereact/dropdown';
import "primereact/resources/primereact.min.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import { classNames } from 'primereact/utils';
import { useEffect, useState } from "react";
import { Button, Col, Container, Form, Image, Row } from "react-bootstrap";
import { Controller, useForm } from 'react-hook-form';
import { MdOutlineCloudUpload, MdOutlineSync } from 'react-icons/md';
import { Link, useNavigate } from 'react-router-dom';
import { getEndpointUrl } from '../../Utils/Common';

const FormElement = ({ onCallback, car, entry, element, currentIndex, isPrev, isLast }) => {
    const { control, register, handleSubmit, formState: { errors }, reset } = useForm();
    const [isLoading, setLoading] = useState(false);
    const [selectedAvailability, setSelectedAvailability] = useState([null]);
    const [selectedChoices, setSelectedChoice] = useState([]);
    const [selectedConditions, setSelectedConditions] = useState([]);
    const [otherInput, setOtherInput] = useState('');
    const [fileImage, setFileImage] = useState([]);

    const navigate = useNavigate();

    const [accesToken] = useState(
        JSON.parse(localStorage.getItem('credentials')) || []
    );

    useEffect(() => {
        let defaultValues = {};

        if (entry.name == element.name) {
            defaultValues.note = entry.note;
            defaultValues.availability = entry.availability;

            if (element.type == 'select') {
                setSelectedAvailability(element.choices.filter(item => item.name == entry.availability).at(0));
                setSelectedChoice(entry.choices != '' ? JSON.parse(entry.choices) : []);
                defaultValues.condition = selectedChoices?.length > 0 ? JSON.stringify(selectedChoices) : '';
            } else {
                let newSelection = [];
                let anotherChoice = null;
                JSON.parse(entry.choices).map((item, key) => {
                    if (element.choices.filter(val => val.name === item).at(0) === undefined) {
                        anotherChoice = item;
                        setOtherInput(item);
                    } else {
                        newSelection.push(item);
                    }
                });

                if (anotherChoice != null)
                    newSelection.push(anotherChoice);

                setSelectedConditions(newSelection);
                setSelectedChoice(newSelection);

                defaultValues.availability = selectedConditions?.length > 0 ? JSON.stringify(selectedConditions) : '';
                defaultValues.condition = selectedConditions?.length > 0 ? JSON.stringify(selectedConditions) : '';
            }
        }

        reset({ ...defaultValues });
    }, [entry]);

    useEffect(() => {
        let defaultValues = {};

        defaultValues.availability = selectedAvailability.name;

        if (element.type == 'select') {
            defaultValues.condition = selectedChoices?.length > 0 ? JSON.stringify(selectedChoices) : '';
        } else {
            defaultValues.availability = selectedConditions?.length > 0 ? JSON.stringify(selectedConditions) : '';
            defaultValues.condition = selectedConditions?.length > 0 ? JSON.stringify(selectedConditions) : '';
        }
        reset({ ...defaultValues });
    }, [selectedAvailability, selectedChoices, selectedConditions, otherInput, fileImage]);

    const onChoicesAvailabilityChange = (e) => {
        let _selected = [...selectedChoices];
        if (e.checked)
            _selected.push(e.value);
        else
            _selected = _selected.filter(item => item !== e.value);

        setSelectedChoice(_selected);
    };

    const onChoicesOtherAvailabilityChange = (e) => {
        let _selected = [...selectedChoices];
        if (e.checked)
            _selected.push(e.value);
        else {
            _selected = _selected.filter(item => item !== e.value);
            setOtherInput('');
        }

        setSelectedChoice(_selected);
    }

    const onChoicesConditionsChange = (e) => {
        let _selected = [...selectedConditions];
        if (e.checked)
            _selected.push(e.value);
        else
            _selected = _selected.filter(item => item.name !== e.value.name);

        setSelectedConditions(_selected);
    };

    const onChoicesOtherConditionsChange = (e) => {
        let _selected = [...selectedConditions];
        if (e.checked)
            _selected.push(e.value);
        else {
            _selected = _selected.filter(item => item !== e.value);
            setOtherInput('');
        }

        setSelectedConditions(_selected);
    }

    const handleFile = (e) => setFileImage(URL.createObjectURL(e.target.files[0]));

    const onSubmit = (data) => {
        setLoading(true);

        let formData = new FormData();    //formdata object

        formData.append('item_id', car?.id);
        formData.append('index', currentIndex);
        formData.append('name', element.name);
        formData.append('availability', data.availability);
        formData.append('choices', data.condition);
        formData.append('note', data.note);
        formData.append('image', data.file?.[0]);

        fetch(getEndpointUrl() + '/checkpoint/send', {
            method: "POST",
            body: formData,
            headers: new Headers({
                Authorization: `Bearer ${accesToken}`,
                'Pragma':'no-cache',
                'Cache-Control' : 'no-cache'
            }),
        }).then(response => response.json()).then(json => {
            if (json.status === 'ok') {
                onCallback(json.results.data);
            } else {

            }
            setLoading(false);
        }).catch(error => {
            setLoading(false);
        });
    };

    return (
        <>
            <Container className="mt-5">
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <Row className="mb-4">
                        <Col>
                            <div>
                                <div className="d-flex justify-content-between">
                                    <div className="page-title">
                                        <h3>{`${element.id}.`}</h3>
                                        <h3>{element.name}</h3>
                                    </div>
                                    <div className="fs-13">
                                        {isLoading ?
                                            <div className="text-muted pt-2">
                                                <MdOutlineSync /><small className="ms-2">Menyimpan...</small>
                                            </div> :
                                            <div className="text-muted pt-2">
                                                <MdOutlineCloudUpload /><small className="ms-2">Draft tersimpan</small>
                                            </div>
                                        }
                                    </div>
                                </div>
                                <div className="fs-14" dangerouslySetInnerHTML={{ __html: element.htmlDescription }}></div>
                            </div>
                        </Col>
                    </Row>
                    {element.type == 'select' ?
                        <>
                            <Row className="mb-4">
                                <Col>
                                    <Form.Label className='fw-bold'>Kelengkapan :</Form.Label>
                                    <div className="clearfix" />
                                    <Controller
                                        render={({ field }) => (
                                            <Dropdown {...field}
                                                optionLabel="name"
                                                placeholder="Pilih Kelengkapan"
                                                id={field.name}
                                                options={element.choices}
                                                value={selectedAvailability}
                                                onChange={(e) => {
                                                    setSelectedAvailability(e.value)
                                                    setSelectedChoice([]);
                                                    setSelectedConditions([]);
                                                }}
                                                className={classNames({ 'p-invalid': errors.availability })}
                                            />
                                        )}
                                        control={control}
                                        name="availability"
                                        rules={{ required: "Field wajib diisi!" }}
                                    />
                                    <div className="clearfix" />
                                    <Form.Text className="text-muted fs-13 clearfix">{errors.availability?.message}</Form.Text>
                                </Col>
                            </Row>
                            {selectedAvailability.choices?.length > 0 &&
                                <Row>
                                    <Col sm={12}>
                                        <Form.Label className="fw-bold">Kondisi dan Fungsi :</Form.Label>
                                        <div className="mt-2 mb-5">
                                            <Controller name="condition" control={control} rules={{ required: "Field wajib diisi!" }} render={({ field }) => (
                                                <>
                                                    {selectedAvailability.choices.map((item, key) =>
                                                        <div key={`select-${key}`} className="d-flex align-items-center mb-3">
                                                            <Checkbox
                                                                inputId={`select-${key}`}
                                                                name="choices"
                                                                value={item}
                                                                disabled={isLoading}
                                                                onChange={onChoicesAvailabilityChange}
                                                                checked={selectedChoices.some((val) => val === item)}
                                                                className={classNames({ 'p-invalid': errors.condition?.message })} />
                                                            <label htmlFor={`select-${key}`} className="ms-3 pointer">{item}</label>
                                                        </div>
                                                    )}
                                                    <div key={`choices-condition`} className="d-flex align-items-center mb-3">
                                                        <Checkbox
                                                            inputId={`choices-condition`}
                                                            name="choices"
                                                            value={otherInput}
                                                            onChange={onChoicesOtherAvailabilityChange}
                                                            disabled={!otherInput?.length > 0 || isLoading}
                                                            checked={selectedChoices.some((val) => val === otherInput)}
                                                            className={classNames({ 'p-invalid': errors.condition?.message })}
                                                        />
                                                        <Form.Group className="ms-3 w-50">
                                                            <Form.Control value={otherInput} size="lg" type="text" placeholder="Pilihan lainnya..." autoComplete="off"
                                                                onChange={(e) => {
                                                                    setOtherInput(e.target.value);
                                                                }}
                                                            />
                                                        </Form.Group>
                                                    </div>
                                                </>
                                            )} />
                                            <Form.Text className="text-muted fs-13 clearfix">{errors.condition?.message}</Form.Text>
                                        </div>
                                    </Col>
                                </Row>
                            }
                        </> :
                        <>
                            {element.choices?.length > 0 &&
                                <Row>
                                    <Col sm={12}>
                                        <Form.Label className="fw-bold">Kondisi dan Fungsi :</Form.Label>
                                        <div className="mt-2 mb-5">
                                            <Controller name="condition" control={control} rules={{ required: "Field wajib diisi!" }} render={({ field }) => (
                                                <>
                                                    {element.choices.map((item, key) =>
                                                        <div key={`choices-${key}`} className="d-flex align-items-center mb-3">
                                                            <Checkbox inputId={`choices-${key}`} name="choices"
                                                                value={item.name}
                                                                onChange={onChoicesConditionsChange}
                                                                disabled={isLoading}
                                                                checked={selectedConditions.some((val) => val === item.name)}
                                                                className={classNames({ 'p-invalid': errors.condition?.message })}
                                                            />
                                                            <label htmlFor={`choices-${key}`} className="ms-3 pointer">{item.name}</label>
                                                        </div>
                                                    )}
                                                    <div key={`choices-a`} className="d-flex align-items-center mb-3">
                                                        <Checkbox inputId={`choices-a`} name="choices"
                                                            value={otherInput}
                                                            onChange={onChoicesOtherConditionsChange}
                                                            disabled={!otherInput?.length > 0 || isLoading}
                                                            checked={selectedConditions.some((val) => val === otherInput)}
                                                            className={classNames({ 'p-invalid': errors.condition?.message })}
                                                        />
                                                        <Form.Group className="ms-3 w-50">
                                                            <Form.Control type="text" placeholder="Pilihan lainnya..." autoComplete="off"
                                                                value={otherInput}
                                                                disabled={isLoading}
                                                                onChange={(e) => {
                                                                    setOtherInput(e.target.value);
                                                                }}
                                                            />
                                                        </Form.Group>
                                                    </div>
                                                </>
                                            )} />
                                            <Form.Text className="text-muted fs-13 clearfix">{errors.condition?.message}</Form.Text>
                                        </div>
                                    </Col>
                                </Row>
                            }
                        </>
                    }
                    <Row>
                        <Col>
                            <Form.Group className="mb-3">
                                <Form.Label className='fw-bold'>Catatan :</Form.Label>
                                <Form.Control type="text" as={'textarea'} rows={5} autoComplete="off" {...register("note")} disabled={isLoading} isInvalid={errors.note ? true : false} />
                                <Form.Text className="text-muted fs-13 clearfix">{errors.note?.message}</Form.Text>
                            </Form.Group>
                        </Col>
                    </Row>
                    {element.image &&
                        <>
                            {fileImage?.length == 0 && entry.image != null &&
                                <Row>
                                    <Col md={6} className="mb-3 mt-3">
                                        <Image src={fileImage?.length != 0 ? fileImage : entry.image != null ? entry.image : fileImage} fluid alt="Image" />
                                    </Col>
                                </Row>
                            }
                            {fileImage?.length != 0 &&
                                <Row>
                                    <Col md={6} className="mb-3 mt-3">
                                        <Image src={fileImage} fluid alt="Image" />
                                    </Col>
                                </Row>
                            }
                            <Row>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label className='fw-bold'>Foto :</Form.Label>
                                        <Form.Control type="file" {...register("file", { required: fileImage?.length != 0 ? false : entry.image != null ? false : true })} isInvalid={errors.file ? true : false} onChange={handleFile} disabled={isLoading} />
                                        <Form.Text className="text-muted fs-13 clearfix">{errors.file?.message}</Form.Text>
                                    </Form.Group>
                                </Col>
                            </Row>
                        </>
                    }
                    <Row>
                        <Col>
                            <div className="d-flex justify-content-between mb-3 mt-4">
                                {currentIndex != 0 ?
                                    <Link to={`/form-inspeksi/${car.id}/${currentIndex - 1}`} className="btn btn-outline-secondary btn-lg me-3">Kembali</Link> :
                                    <Link  onClick={() => navigate(-1)} className="btn btn-outline-secondary btn-lg me-3">Batalkan</Link>
                                }
                                <Button size="lg" type="submit" disabled={isLoading}>{isLast ? "Simpan" : "Lanjutkan"}</Button>
                            </div>
                        </Col>
                    </Row>

                </Form>
            </Container>

        </>
    );
}

export default FormElement;
